import _ from 'lodash';

/**
 * Append row, period subtotal rows (and passthrough the tool-provided grand total) so the
 * pivot view can render Total column / Total row / corner cell by direct lookup.
 *
 * The caller supplies an `aggregate(rows)` function because correct aggregation
 * (especially of ratios) is domain-specific. This helper does no math itself.
 */
export function appendPivotSubtotals({
  rows,
  rowTypeField = 'rowType',
  totalValue = 'total',
  rowDimKeys,
  periodKeys,
  aggregate,
}) {
  const bodyRows = rows.filter((r) => r[rowTypeField] !== totalValue);
  if (bodyRows.length === 0 || rowDimKeys.length === 0 || periodKeys.length === 0) return rows;

  const pickKeys = (row, keys) => Object.fromEntries(keys.map((k) => [k, row[k]]));

  const rowSubtotals = Object.values(_.groupBy(bodyRows, (r) => rowDimKeys.map((k) => r[k] ?? '').join('|'))).map(
    (group) => ({ ...pickKeys(group[0], rowDimKeys), ...aggregate(group), [rowTypeField]: 'rowSubtotal' }),
  );

  const periodSubtotals = Object.values(_.groupBy(bodyRows, (r) => periodKeys.map((k) => r[k] ?? '').join('|'))).map(
    (group) => ({ ...pickKeys(group[0], periodKeys), ...aggregate(group), [rowTypeField]: 'periodSubtotal' }),
  );

  return [...rows, ...rowSubtotals, ...periodSubtotals];
}
